import {UseFormReturn} from "react-hook-form";

import {SUCCESS_MESSAGES} from "@/lib/constants/subscribeDropdown";
import {SubscriptionType} from "@/lib/types/statuspages";

import {SlackTabContent} from "./SlackTabContent";
import {SubscribeFormValues} from "./SubscribeDropdown.types";
import {SubscribeFormContent} from "./SubscribeFormContent";

import styles from "./SubscribeDropdown.module.scss";

export interface TabContentProps {
  methods: UseFormReturn<SubscribeFormValues>;
  onSubmit: (values: SubscribeFormValues) => Promise<void>;
  activeType: SubscriptionType;
  successType: SubscriptionType | null;
  serverError: string | null;
  loading: boolean;
  resolvedRssUrl: string | null;
  copied: boolean;
  slackOAuthUrl?: string | null;
}

export const TabContent = ({
  methods,
  onSubmit,
  activeType,
  successType,
  serverError,
  loading,
  resolvedRssUrl,
  copied,
  slackOAuthUrl,
}: TabContentProps) => {
  if (successType) {
    return <p className={styles.successText}>{SUCCESS_MESSAGES[successType]}</p>;
  }

  if (activeType === SubscriptionType.SLACK && slackOAuthUrl) {
    return <SlackTabContent serverError={serverError} slackOAuthUrl={slackOAuthUrl} />;
  }

  return (
    <SubscribeFormContent
      methods={methods}
      onSubmit={onSubmit}
      activeType={activeType}
      resolvedRssUrl={resolvedRssUrl}
      serverError={serverError}
      loading={loading}
      copied={copied}
    />
  );
};
